const EMAIL_AUTOLINK_EXECUTE_FLOW_PARAMETER = "EMAIL_AUTOLINK_EXECUTE";

export default function getEmailAutolinkPayload(state) {
  const password = state.loginForm.signup?.password?.trim() || state.loginForm.password?.trim() || "";
  const clientId = state.loginForm.clientId || "";
  const accountNumber = state.loginForm.signup?.accountNumber?.trim() || state.loginForm.accountNumber?.trim() || "";
  return {
    client_id: clientId.trim(),
    password: password.trim(),
    accountNumber: accountNumber.toLowerCase(),
    flowParameter: EMAIL_AUTOLINK_EXECUTE_FLOW_PARAMETER
  };
}